import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsWarning } from '@deephaven/icons';
import ThemeExport from "./ThemeExport.js";
import LoadingSpinner from "./LoadingSpinner.js";
import "./LoadingOverlay.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A loading overlay that handles displaying a loading spinner or an error message
 */
function LoadingOverlay(_ref) {
  var {
    isLoaded = false,
    isLoading = true,
    errorMessage = null,
    'data-testid': dataTestId
  } = _ref;
  var messageTestId = dataTestId != null ? "".concat(dataTestId, "-message") : undefined;
  var spinnerTestId = dataTestId != null ? "".concat(dataTestId, "-spinner") : undefined;
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: Boolean(errorMessage) || !isLoaded || isLoading,
    timeout: ThemeExport.transitionMs,
    classNames: isLoaded ? 'fade' : '',
    mountOnEnter: true,
    unmountOnExit: true,
    children: /*#__PURE__*/_jsx("div", {
      className: "fill-parent-absolute",
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx("div", {
        className: classNames('iris-panel-message-overlay', 'fill-parent-absolute', {
          'iris-panel-scrim-background': isLoaded
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: "message-content",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "message-icon",
            children: [isLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
              "data-testid": spinnerTestId
            }), !isLoading && errorMessage != null && /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsWarning
            })]
          }), errorMessage != null && /*#__PURE__*/_jsx("div", {
            className: "message-text",
            "data-testid": messageTestId,
            children: errorMessage
          })]
        })
      })
    })
  });
}
export default LoadingOverlay;
//# sourceMappingURL=LoadingOverlay.js.map